/**
 * Stripe Configuration for Public Booking
 *
 * Provides publishable key for initializing Stripe Elements.
 */

// Stripe publishable key - MUST be set in production
export const STRIPE_PUBLISHABLE_KEY =
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || "";

// Validate that Stripe key is configured
export function isStripeConfigured(): boolean {
  return STRIPE_PUBLISHABLE_KEY.length > 0;
}
